import React from 'react';
import './index.scss';
import LazyLoadImg from '../aelComponent/LazyLoadImg';
import api from '../../service/api';

class HotProductsItem extends React.Component {
  handleProduct(val) {
    let product = {
      productID: val.productID,
      image: val.image,
      name: val.title1,
      brand: val.title2,
      priceTag: val.originalPrice
    }
    if (val.productInfo) {
      let productInfo = val.productInfo;

      if (productInfo.colors) {
        product['colors'] = productInfo.colors.length
      }
      if (productInfo.brand) {
        product['brand'] = productInfo.brand
      } else if (productInfo.displayBrand) {
        product['brand'] = productInfo.displayBrand
      }
      if (productInfo.nameCN) {
        product['name'] = productInfo.nameCN
      } else if (productInfo.name) {
        product['name'] = productInfo.name
      }
      if (productInfo.origin) {
        product['origin'] = productInfo.origin
      }
      if (productInfo.merchantName) {
        product['merchantName'] = productInfo.merchantName
      }
      if (productInfo.priceTag) {
        product['priceTag'] = productInfo.priceTag
      }
      if (productInfo.originalPriceTag) {
        product['originalPriceTag'] = productInfo.originalPriceTag
      }
      if (productInfo.priceTagCN) {
        product['priceTagCN'] = productInfo.priceTagCN
      }
      if (productInfo.favoritedCount) {
        if (productInfo.favoritedCount > 9999) {
          product['favoritedCount'] = (productInfo.favoritedCount / 1000).toFixed(1) + 'w人收藏'
        } else {
          product['favoritedCount'] = productInfo.favoritedCount + '人收藏'
        }
      }
      if (productInfo.activityOffs) {
        product['activityOffs'] = productInfo.activityOffs
      }

      if (productInfo.inventoryStatus) {
        product['inventoryStatus'] = productInfo.inventoryStatus;
      }
    }
    return product;
  }

  render() {
    let {
      product,
      index
    } = this.props;
    product = this.handleProduct(product);
    return (
      <a className='hotProductsItem' href={`/pd/${product.productID}/`}>
        <div
          data-type='hotProducts'
          data-index={index}
        >
          <div className={index % 4 == 0 || index % 4 == 3 ? 'h_p_i_imgBox h_p_i_imgBox_bg' : 'h_p_i_imgBox'}>
            {
              <LazyLoadImg image={api.getResource(product.image)} alt={`${product.displayBrand || product.brand || ''} ${product.name || ''} product img`} className='h_p_i_imgBox_img'></LazyLoadImg>
            }
            {
              product.colors > 1 ? <div className='h_p_i_imgBox_colors'>{product.colors}色可选</div> : <div></div>
            }
            {
              product.inventoryStatus && product.inventoryStatus === 'UNAVAILABLE' && <div className='sold_out'>
                已售罄
              </div>
            }
          </div>
          <div className="h_p_i_textBox">
            <div className='h_p_i_title1'>{product.brand && product.brand + ' |' || product.displayBrand && product.displayBrand + '|'} {product.name}</div>
            {
              (product.origin || product.merchantName) && <div className='h_p_i_title2'>{product.origin} {product.merchantName}</div>
            }
            <div className='h_p_i_priceUS'>
              {product.priceTag && <span className='h_p_i_priceUS_discount'>{product.priceTag}</span>}
              <span className='h_p_i_priceUS_origin'>{product.originalPriceTag}</span>
            </div>
            <div className='h_p_i_priceCNAndLike'>
              <span className={`h_p_i_priceCN ${product.originalPriceTag ? 'blueColor' : ''}`}>{product.priceTagCN}</span>
              <span className='h_p_i_like'>{product.favoritedCount}</span>
            </div>
            <div className='promoMsg'>
              {
                product.activityOffs && product.activityOffs.map((val, index) => {
                  return (
                    <div key={index}>
                      {
                        product.activityOffs.length - 1 != index
                          ? <div className='promoMsg'>
                            <span className='promoMsg_text'>{val}</span>
                            <div className='promoMsg_textLine'></div>
                          </div>
                          : <div className='promoMsg'><span className='promoMsg_text promoMsg_text_last'>{val}</span></div>
                      }
                    </div>
                  )
                })
              }
            </div>
          </div>
        </div>
      </a>
    )
  }
}

export default HotProductsItem